import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {onMounted, ref} from "vue"
  import Button from "@/components/button.vue"
  import NumberInput from "@/components/inputs/number.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'paginator',
  props: /*@__PURE__*/_mergeModels({
    itemTotal: {
      default: null,
      required: true,
      type: Number,
    }
  }, {
    "currentPage": {
    default: null,
    required: true,
    type: Number,
  },
    "currentPageModifiers": {},
    "pageItems": {
    default: null,
    required: true,
    type: Number,
  },
    "pageItemsModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["update"], ["update:currentPage", "update:pageItems"]),
  setup(__props, { emit: __emit }) {

  const props = __props

  const emits = __emit

  const currentPage = _useModel(__props, "currentPage")
  const pageItems = _useModel(__props, "pageItems")
  const pageTotal = ref<number>(null)

  onMounted(() => {
    updatePaginator()
  })

  function updatePaginator() {
    if (props.itemTotal < 1 || pageItems.value < 1) {
      pageTotal.value = 0
    } else {
      pageTotal.value = Math.ceil(props.itemTotal / pageItems.value)
    }
    currentPage.value = 1
  }

  function nextPage() {
    if (currentPage.value >= pageTotal.value) {
      currentPage.value = pageTotal.value
    } else {
      currentPage.value ++
    }
    emits("update")
  }
  
  function previousPage() {
    if (currentPage.value <= 1) {
      currentPage.value = 1
    } else {
      currentPage.value --
    }
    emits("update")
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(Button, {
          title: "⇦",
          disabled: currentPage.value <= 1,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (previousPage()))
        }, null, 8, ["disabled"]),
        _cache[4] || (_cache[4] = _createTextVNode(" Page ", -1)),
        _createVNode(NumberInput, {
          value: currentPage.value,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
          class: "number",
          max: pageTotal.value,
          min: 1,
          onChange: _cache[2] || (_cache[2] = ($event: any) => (emits('update')))
        }, null, 8, ["value", "max"]),
        _createTextVNode(" of " + _toDisplayString(pageTotal.value) + " ", 1),
        _createVNode(Button, {
          title: "⇨",
          disabled: currentPage.value >= pageTotal.value,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (nextPage()))
        }, null, 8, ["disabled"])
      ])
    ]),
    _: 1
  }))
}
}

})